import type { AdminCenterClientsResponse } from '@routes/sidebar/admin-center/___shared___/api/adminCenter.api.ts';
import type { DataType } from '@routes/sidebar/admin-center/tenant-client/ui/tenant-client-groupBy-table/types.ts';

export const mapResponseToRows = (resp: AdminCenterClientsResponse): DataType[] =>
    resp.data.flatMap((client) =>
        client.tenants.map((t) => ({
            key: `${client.id}-${t.id}`,
            client: client.name,
            clientName: client.name, // used by sizing; safe duplicate
            tenantName: t.name,
            active: t.active,
            canBeActivated: t.canBeActivated,
            tenantType: t.tenantType,
            dateModified: t.dateModified ?? '',
            subscriptions: t.subscriptions ?? 0,
            learning: t.learning ?? 0,
            assessment: t.assessment ?? 0,
        })),
    );
